import script from "./MinOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./MinOrder.vue?vue&type=script&setup=true&lang=js"

import "./MinOrder.vue?vue&type=style&index=0&id=5a38328c&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a38328c"]])

export default __exports__